import { render, staticRenderFns } from "./FiltersUsedOnSearchTableTab.vue?vue&type=template&id=b4bb2eb6&scoped=true&"
import script from "./FiltersUsedOnSearchTableTab.vue?vue&type=script&lang=ts&"
export * from "./FiltersUsedOnSearchTableTab.vue?vue&type=script&lang=ts&"
import style0 from "./FiltersUsedOnSearchTableTab.vue?vue&type=style&index=0&id=b4bb2eb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4bb2eb6",
  null
  
)

export default component.exports